import { render, staticRenderFns } from "./bWflowViewer.vue?vue&type=template&id=da5a9d20&"
import script from "./bWflowViewer.vue?vue&type=script&lang=js&"
export * from "./bWflowViewer.vue?vue&type=script&lang=js&"
import style0 from "./bWflowViewer.vue?vue&type=style&index=0&id=da5a9d20&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports